import React, { useEffect, useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { FAQ_COLLECTION, serverTimestamp } from '../../firebase'
import { useParams } from 'react-router';
import { useHistory } from "react-router-dom";

const INITIAL_STATE = {
    date: serverTimestamp.now(),
    description_en: '',
    description_sr: '',
    title_en: '',
    title_sr: ''
}

const EditFaq = () => {

    const { id } = useParams()

    const history = useHistory()

    const [edit, setEdit] = useState(INITIAL_STATE)

    const handleEdit = async (e) => {

        e.preventDefault();

        await FAQ_COLLECTION.doc(id).set({
            _id: id,
            contact: edit.contact,
            date: edit.date,
            done: edit.done,
            game: edit.game,
            method_of_payment: edit.method_of_payment,
            name: edit.name,
            price: edit.price
        })
            .then(() => {
                alert("Uspješno uređeno 👍")
                history.push('/preview-faq')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await FAQ_COLLECTION.where('_id', '==', id).get()
            snapshot.forEach(doc => {
                setEdit(doc.data())
            })
        }

        getItems();

    }, []);

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="edit-faq" className="mb-3" transition={false}>
                    <Tab eventKey="preview-faq" title={<div onClick={() => history.push('/preview-faq')}>Pregled faq</div>} />
                    <Tab eventKey="add-faq" title={<div onClick={() => history.push('/add-faq')}>Dodaj</div>} />
                    <Tab eventKey="edit-faq" title="Uredi">
                        <Form onSubmit={handleEdit}>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Opis (EN)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Opis (EN)"
                                            value={edit.description_en}
                                            onChange={(e) => { setEdit({ ...edit, description_en: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Opis (SR)</Form.Label>
                                        <Form.Control
                                            rows={5}
                                            as="textarea"
                                            placeholder="Unesite - Opis (SR)"
                                            value={edit.description_sr}
                                            onChange={(e) => { setEdit({ ...edit, description_sr: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Naslov (EN)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Naslov (EN)"
                                            value={edit.title_en}
                                            onChange={(e) => { setEdit({ ...edit, title_en: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Naslov (SR)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Unesite - Naslov (SR)"
                                            value={edit.title_sr}
                                            onChange={(e) => { setEdit({ ...edit, title_sr: e.target.value }) }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Button variant="primary" type="submit">
                                        Uredi
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="delete-faq" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default EditFaq
